import { Helmet } from "react-helmet-async";
import { BUSINESS } from "../content/site";

export const Seo = ({ title, description, path = "/", noindex = false, jsonLd }) => {
  const url = `${BUSINESS.domain}${path === "/" ? "/" : path}`;
  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
      {(jsonLd || []).map((j, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(j)}</script>
      ))}
    </Helmet>
  );
};

export const breadcrumbLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map(([name, path], i) => ({ "@type": "ListItem", position: i + 1, name, item: `${BUSINESS.domain}${path}` })),
});

export const faqLd = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
});

export const serviceLd = (name, description, path) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name,
  description,
  url: `${BUSINESS.domain}${path}`,
  areaServed: { "@type": "City", name: "Asheville, NC" },
  provider: { "@type": "Plumber", "@id": `${BUSINESS.domain}/#plumber`, name: BUSINESS.name, telephone: "+1-828-974-6147" },
});
